// extracted by mini-css-extract-plugin
module.exports = {"vingette":"vingette__Mr0nZ","playButton":"playButton__3Yk-Y","fade":"fade__3JBOK","container":"container__Y4WIL"};